import { BaseMapper } from '@ps/utils';
import { SurveySocketUpdatePayload } from '@ps/survey-utils';

import { SurveyDashboardSocketDto } from '../dtos/survey-socket.dto';

export class SurveyDashboardSocketMapper extends BaseMapper<
  SurveyDashboardSocketDto,
  SurveySocketUpdatePayload
> {
  public fromDto({
    surveyManagement,
  }: SurveyDashboardSocketDto): SurveySocketUpdatePayload {
    return {
      surveyId: surveyManagement.survey_id,
      survey: {
        fielded: surveyManagement.fielded,
        aCpi: surveyManagement.acpi,
        avgCpi: surveyManagement.averageCpi,
        recentLoi: surveyManagement.recent_loi,
        recentIr: surveyManagement.recent_incidence,
        totalCost: {
          current: surveyManagement.total_cost_current,
          projected: surveyManagement.total_cost_projected,
        },
        cpi: {
          current: surveyManagement.cpi_current,
          projected: surveyManagement.cpi_projected,
        },
      },
    };
  }
}
